import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220 } from "@faire/web-api--source/indigofair/settings/ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220";

export const useSettingMultimodalProductSearch = (): boolean =>
  useSetting(ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220, false);

export const getSettingMultimodalProductSearch = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220,
    false
  );
